<template>
  <div id="subOutputRank-print" class="page-break">
    <el-row>
      <el-col :span="24">
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000" v-if="AGENT == 0">
          {{ payableName? payableName: this.companyName }}送货验收单
        </h1>
        <h1 style="text-align: center;margin-top: 0;padding-top: 0;color: #000" v-if="AGENT == 1">送货验收单</h1>
      </el-col>
    </el-row>
    <el-row style="margin-top:50px;">
      <el-col :span="3" v-if="ORDER_TC_ID != 293">
        <img :src="imgUrl" style="width: 92%">
      </el-col>
      <el-col v-if="topData.length > 0" :span="9">
        <ul>
          <li v-if="AGENT == 0">
            供&nbsp;&nbsp;应&nbsp;&nbsp;商：{{ payableName? payableName: topData[0].SUPPLIER_NAME }}
          </li>
          <li v-if="AGENT == 1">委&nbsp;&nbsp;托&nbsp;&nbsp;方：{{ topData[0].PRINCIPAL_NAME }}</li>
          <li v-if="AGENT == 1">收&nbsp;&nbsp;货&nbsp;&nbsp;方：{{ topData[0].CUSTOM_NAME }}</li>
          <li>项&nbsp;&nbsp;目&nbsp;&nbsp;点：{{ topData[0].PROJECT_NAME }}</li>
          <li>项目点地址：{{ topData[0].PROJECT_ADDRESS }}</li>
        </ul>
      </el-col>
      <el-col :span="12" style="padding-left: 70px">
        <ul>
          <li v-if="AGENT == 0">制&nbsp;&nbsp;单&nbsp;&nbsp;人：{{ managername }}</li>
          <li v-if="AGENT == 1">送&nbsp;&nbsp;货&nbsp;&nbsp;方：{{ topData[0].TRUSTEE_NAME }}</li>
          <li>档&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;口：{{ topData[0].DK_NAME }}</li>
          <li>{{ topData[0].PROJECT_TELPHONE }}</li>
          <li>订&nbsp;单&nbsp;编号：{{ topData[0].ORDER_CODE }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期：{{ topData[0].SEND_DAY }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <table style="width: 100%">
          <tr>
            <th style="width: 5%">序号</th>
            <th style="width: 30%">品名</th>
            <th style="width: 5%">单位</th>
            <th style="width: 8%">订购数量</th>
            <th style="width: 8%">实收数量</th>
            <th style="width: 10%">叮咚对标价格</th>
            <th style="width: 10%">下浮后单价</th>
            <th style="width: 10%">总价</th>
            <th style="width: 10%">下浮后总价</th>
            <th>备注</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <!-- 序号 -->
            <td>{{ item.ID }}</td>
            <!-- 品名 -->
            <td>{{ item.PRODUCT_NAME }}</td>
            <!-- 单位 -->
            <td>{{ item.TYPE_UNIT }}</td>
            <!-- 订购数量 -->
            <td>{{ item.PRODUCT_COUNT }}</td>
            <!-- 实收数量 -->
            <td>{{ topData[0].STATUS > 3 ? item.REAL_COUNT : '' }}</td>
            <!-- 叮咚对标价格 -->
            <td>{{ item.COMPARE_WEBSITE_PRICE }}</td>
            <!-- 下浮后单价 -->
            <td>{{ (item.COMPARE_WEBSITE_PRICE * websitePriceRate / 100).toFixed(2) }}</td>
            <!-- 总价 -->
            <td>{{ (Math.round((item.PRODUCT_COUNT * item.COMPARE_WEBSITE_PRICE) * 100) / 100).toFixed(2)}}</td>
            <!-- 下浮后总价 -->
            <td>{{ (Math.round(item.PRODUCT_COUNT * item.COMPARE_WEBSITE_PRICE * websitePriceRate) / 100).toFixed(2)}}
            </td>
            <!-- 备注 -->
            <td>{{ item.PRODUCT_COMMENT }}</td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="6">
        <span>收货时间：</span>
      </el-col>
      <el-col :span="6">
        <span>送货线路：{{ topData[0].LINE_NAME }}</span>
      </el-col>
      <el-col :span="6" :offset="6">
        <span>订单总金额：{{ project_total_fee }}</span>
      </el-col>
    </el-row>
    <el-row v-if="ORDER_TC_ID == 293">
      <el-col :span="6">
        <span>送货员：</span>
      </el-col>
      <el-col :span="6">
        <span>项目经理：{{ accociated_person[0].MANAGER_NAME }}</span>
      </el-col>
      <el-col :span="6">
        <span>厨师长：{{ accociated_person[0].DK_LEADER_NAME }}</span>
      </el-col>
      <el-col :span="6">
        <span>验收人员：</span>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :span="6">
        <span>送货员：</span>
      </el-col>
      <el-col :span="6">
        <span>项目经理：</span>
      </el-col>
      <el-col :span="6">
        <span>厨师长：</span>
      </el-col>
      <el-col :span="6">
        <span>验收人员：</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" :offset="21" style="padding: 0">
        <p>第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    supplier: String,
    PROJECT_TOTAL_FEE: Number,
    TOTAL_PROJECT_NEED_PRICE: Number,
    TOTAL_PROJECT_REAL_FEE: Number,
    ASSOCIATED_PERSON: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    acceptanceQRCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      topData: [],
      mainData: [],
      managername: '',
      supplier_name: '',
      accociated_person: [],
      imgUrl: '',
      printSupplier: '',
      companyName: '',
      payableName: sessionStorage.getItem('payableName'),
      printName: sessionStorage.getItem('supplierName'),
      countFlag: sessionStorage.getItem('countFlag'),
      printRealFlag: Number(sessionStorage.getItem('printRealFlag')),
      ORDER_TC_ID: sessionStorage.getItem('ORDER_TC_ID') || '',
      AGENT: 0,
      NEED_tcName: sessionStorage.getItem('NEED_TCNAME'),
      noCode: sessionStorage.getItem('noCode') || '0',
      project_total_fee: 0,
      total_project_need_price: 0,
      tatal_project_real_fee: 0,
      websitePriceRate: Number(sessionStorage.getItem('websitePriceRate')),
    };
  },
  created() {
    this.AGENT = sessionStorage.getItem('AGENT');
    this.topData = this.headerData;
    this.supplier_name = this.headerData[0].SUPPLIER_NAME;
    this.mainData.push(this.tableData);
    this.managername = this.manager;
    this.printSupplier = this.supplier;
    this.project_total_fee = this.PROJECT_TOTAL_FEE.toFixed(2);
    this.total_project_need_price = this.TOTAL_PROJECT_NEED_PRICE.toFixed(2);
    this.tatal_project_real_fee = this.TOTAL_PROJECT_REAL_FEE.toFixed(2);
    this.accociated_person = this.ASSOCIATED_PERSON;
    this.companyName = sessionStorage.getItem('company');
    // this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;
    this.imgUrl = this.$util.getURLLocalHost(`/file/${this.acceptanceQRCode}`);
  },
  destroyed() {
    sessionStorage.removeItem('noCode');
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 20px;
  line-height: 30px;
  color: #000;
  font-family: 黑体;
}

span {
  font-size: 20px;
  line-height: 35px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 20px;
  height: 24px;
  font-family: 黑体;
  color: #000;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/websitePricePrintTax.vue